<template>
  <div class="rules">
    <div class="layout-main clearfix">
      <div class="content-area">
        <div class="title">迅玩游戏玩家守则</div>
        <div class="time">2020-08-01</div>
        <div class="content">
          <p class="ql-long-13967599">
            <strong class="ql-author-13967599 ql-font-microsoftyahei"
              >总则：</strong
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <strong class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >一、玩家违规处罚方式：</strong
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >1.关闭聊天功能：强制暂停玩家角色的在线对话功能，使玩家角色无法与其它玩家对话，直到本次处罚到期或取消。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >2.强制离线：强制将玩家帐号注销登录，结束玩家游戏程序的执行。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >3.监禁：强制将玩家角色移置于独立不可出入的地图中直到本次处罚到期或取消。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >4.删除角色或装备：强制删除玩家的特定角色或装备。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >5.封停游戏帐号：暂时停止玩家游戏帐号及服务</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >功能</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >的使用。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >6.删除游戏帐号：强制删除玩家游戏帐号及取消其游戏权利。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >7.其他官方认为适合的方式。</span
            >
          </p>
          <p>&nbsp;</p>
          <p class="ql-direction-ltr ql-long-13967599">
            <strong class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >二、玩家在游戏中不得有以下行为：</strong
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >1.违反宪法确定的基本原则；</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >2.危害国家统一、主权和领土完整；</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >3.泄露国家秘密、危害国家安全或者损害国家荣誉和利益；</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >4.煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯；</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >5.宣扬邪教、迷信；</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >6.散布谣言，扰乱社会秩序，破坏社会稳定；</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >7.宣扬淫秽、色情、赌博、暴力，或者教唆犯罪；</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >8.侮辱、诽谤他人，侵害他人合法权益；</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >9.违背社会公德；</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >10.法律、行政法规和国家规定禁止的其他行为。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >若玩家在游戏中存在以上行为，官方有权根据情节严重程度，采取玩家违规处罚方式中的一种或几种进行处罚。</span
            >
          </p>
          <p>&nbsp;</p>
          <p class="ql-long-13967599">
            <strong class="ql-author-13967599 ql-font-microsoftyahei"
              >分则：</strong
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <strong class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >三、玩家之间违规行为处罚：</strong
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >1.行为：持续或重复性发言，包括但不限于公屏发广告、恶意刷屏影响发言环境</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >、</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >辱骂</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >或</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >人身攻击其他玩家，妨碍其他玩家正常游戏。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：根据情节严重程度，将予以关闭</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >角色</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >聊天功能、监禁、封停角色、</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >封停</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >帐号及暂停各项服务使用的处罚。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-51393745">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >2.行为：</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >恶意封堵游戏地图中狭窄的路口给其他玩家游戏角色造成行动不便。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-51393745">
            <span class="ql-author-51393745 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：根据情节严重程度，将予监禁、封停角色、</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >封停</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >帐号及暂停各项服务使用的处罚。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-51393745">&nbsp;</p>
          <p class="ql-direction-ltr ql-long-13967599">
            <strong class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >四、玩家游戏内违规行为处罚：</strong
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >1.行为：使用违反命名规则的角色名称、帮派名称，包括但不限于含有人身攻击、名称故意谐音侵犯他人、淫秽、辱骂、反动、与GM服务角色名相似、过多特殊标点符号等影响玩家游戏体验、有损本游戏形象、扰乱正常服务秩序以及</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >有</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >违国家利益和社会公德的文字。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：暂</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >时封停游戏角色</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >，玩家应当主动联系官方修改角色名称</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >。如玩家处罚后再次出现违规行为</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >，</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >将被</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >永久封停其游戏角色。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >2.行为：使用网络加速器等外挂软件或机器人程式等恶意破坏服务设施、扰乱游戏正常秩序。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >一经发现，将</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >封停</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >其</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >帐号，并按照影响范围叠加处罚。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >3.行为：利用系统的BUG、漏洞为自己及他人牟利。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：查证属实后，</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >对于情节较轻的，</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >清除/回收该玩家的不当获利</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >。</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >对于情节严重的，</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >一经发现将</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >封停</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >对应</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >帐号。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >4.行为：同一IP在同一区服登录角色超10个，或使用特殊的方法造成单帐号在同一游戏同一区服内的角色创建数超过原系统设置上限。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >一经发现</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >，我们将</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >第一时间</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >对所有帐号做出冻结帐号处理，情况较轻的玩家给予封停帐号7天处理，情节严重的永久封停帐号。</span
            >
          </p>
          <p class="ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10">5</span
            ><strong class="ql-author-13967599 ql-size-10">.</strong
            ><span class="ql-author-13967599 ql-size-10">行为：</span
            ><span class="ql-author-13967599 ql-size-10"
              >通过公开喊话、私聊</span
            ><span class="ql-size-10 ql-author-51393745">等聊天渠道</span
            ><span class="ql-size-10 ql-author-13967599"
              >或者其他社交软件（包括但不限于QQ、YY、微信）等任何形式、行为，</span
            ><span class="ql-size-10 ql-author-51316056">引导</span
            ><span class="ql-size-10 ql-author-51393745">本平台</span
            ><span class="ql-size-10 ql-author-51316056">玩家</span
            ><span class="ql-size-10 ql-author-13967599">到其他游戏平台</span
            ><span class="ql-size-10 ql-author-51316056">体验产品的</span
            ><span class="ql-size-10 ql-author-13967599">。</span>
          </p>
          <p class="ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10"
              >处罚措施：直接封停该玩家帐号，并按照影响范围叠加处罚。</span
            >
          </p>
          <p>&nbsp;</p>
          <p class="ql-direction-ltr ql-long-13967599">
            <strong
              ><span
                class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
                >五、玩家和</span
              ><span
                class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
                >管理员（GM）</span
              ><span
                class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
                >之间的几种违规行为及处罚：</span
              ></strong
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >1.行为：在游戏中无故呼叫管理员（GM），并且频繁地发骚扰信息给</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >管理员（GM）</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：关闭该玩家聊天功能、监禁、封停游戏帐号。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >2.行为：不服从</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >管理员（GM）</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >安排、对</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >管理员（GM）</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >辱骂。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：禁言、监禁、封停游戏帐号等处罚。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >3.行为：在游戏中假冒</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >管理员（GM）</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >或其他客户服务人员。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：封停该角色，如果多次发现将删除该游戏帐号。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-51316056">
            <span class="ql-author-51316056 ql-size-10 ql-font-microsoftyahei"
              >4.行为：在咨询服务工具上无故骚扰或辱骂</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >管理员（GM）</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-51316056">
            <span class="ql-author-51316056 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：情节较轻者，关闭当次咨询会话；情节严重者，限制或关闭其对应咨询工具的使用权限。</span
            >
          </p>
          <p>&nbsp;</p>
          <p class="ql-direction-ltr ql-long-13967599">
            <strong
              ><span
                class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
                >六、对盗号及其相关行为的处罚：</span
              ></strong
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >1.行为：在游戏中盗取</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >、销毁、转卖</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >他人物品</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：一经查实将永久封停该玩家账号。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >2.行为：协助盗号者操作及转移游戏道具。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：监禁、封停帐号等处罚，情节严重者将永久封停</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >账号</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >处理。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >3.行为：通过不正当渠道获得游戏道具等行为。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：回收该玩家的不当获利，并给予封停</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >账号</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >惩罚。</span
            >
          </p>
          <p><strong>&nbsp;</strong></p>
          <p class="ql-direction-ltr ql-long-13967599">
            <strong
              ><span
                class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
                >七、私自交易行为及处罚：</span
              ></strong
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >1.</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >行为：</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >私自进行游戏账号交易。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：封停游戏账号或删除游戏账号。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >2.</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >行为：</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >私自进行游戏币、游戏道具、游戏装备等交易。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >处罚措施：</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >情节较轻者，</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >删除交易</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >的</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >游戏币、道具、装备等</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >；情节较重者，</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >封停游戏账号或删除游戏账号。</span
            >
          </p>
          <p>&nbsp;</p>
          <p class="ql-direction-ltr ql-long-13967599">
            <strong class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >八、账号安全管理：</strong
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >1.请勿相信游戏中发布的虚假信息，一切以官方网站及人员发布</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >的公告</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51393745"
              >、</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >通知</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >、解释</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >为准。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >2.请保管好账号及密码，不要向任何人透露，</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >因玩家账号密码保管不当而造成</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >的损失</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-51316056"
              >需</span
            ><span class="ql-size-10 ql-font-microsoftyahei ql-author-13967599"
              >由玩家自己承担。</span
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >3.请勿私下交易账号、装备等，由此产生的损失官方不承担责任。</span
            >
          </p>
          <p><span class="ql-font-microsoftyahei ql-size-10">&nbsp;</span></p>
          <p class="ql-long-13967599">
            <strong class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >附则：</strong
            >
          </p>
          <p class="ql-direction-ltr ql-long-13967599">
            <span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >本玩家守则为迅玩《迅雷产品服务使用协议》（<span
                style="color: #3366ff;"
                ><a
                  style="color: #3366ff;"
                  href="https://i.xunlei.com/policy/agreement.html"
                  target="_blank"
                  rel="noopener"
                  >https://i.xunlei.com/policy/agreement.html</a
                ></span
              ></span
            ><span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >）和《“迅雷会员”服务协议</span
            ><span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >》（<span style="color: #3366ff;"
                ><a
                  style="color: #3366ff;"
                  href="https://vip.xunlei.com/pan/tos.html"
                  target="_blank"
                  rel="noopener"
                  >https://vip.xunlei.com/pan/tos.html</a
                ></span
              ></span
            ><span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >）</span
            ><span class="ql-author-13967599 ql-size-10 ql-font-microsoftyahei"
              >的有效组成部分，玩家在游戏时应仔细阅读，并严格遵守，共同营造和维护良好的游戏环境。</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" src="~/assets/scss/rules.scss"></style>
